import React from 'react';
import { gql } from 'urql';
import { RankLineItemFragment } from '../../../../generated/spin-graphql';

type Props = {
    lineItem: RankLineItemFragment;
};

gql`
    fragment RankLineItem on espin_org_player {
        rank
        gpa
        grad_class
        game_rank
        username
        school {
            display_name
        }
    }
`;

export const PlayerLineItem: React.FC<Props> = ({ lineItem }) => {
    return (
        <div className="rankings-row">
            <div className="rankings-data">{lineItem?.rank ?? '-'}</div>
            <div className="rankings-data">{lineItem?.username ?? 'Username'}</div>
            <div className="rankings-data">{lineItem?.grad_class ?? 'Grad Class'}</div>
            <div className="rankings-data">{lineItem?.school?.display_name ?? 'School Name'}</div>
            <div className="rankings-data">{lineItem?.game_rank ?? 'Rank'}</div>
            <div className="rankings-data">{lineItem?.gpa ?? '-'}</div>
        </div>
    );
};
